import React, { useRef, useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from '@fortawesome/free-solid-svg-icons'

import './Header.css'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const headerRef = useRef(null);
  const history = useHistory();
  const location = useLocation();

  const handleDocumentScroll = () => {
    const wScroll = window.scrollY
    if (wScroll > 40) {
      headerRef.current.classList.add('header--scroll')
    } else {
      headerRef.current.classList.remove('header--scroll')
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleDocumentScroll);

    return () => window.removeEventListener('scroll', handleDocumentScroll)
  }, [])

  const goTo = (path) => {
    history.push(path)
    setIsMenuOpen(false)
  }

  return (
    <header ref={headerRef} className={location.pathname !== '/' ? 'header--white' : null}>
      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col-8">
            <div className="logo-text">
              <Link to="/">
                <h1 className="mb--0">OTO.CMD</h1>
              </Link>
            </div>
          </div>
          <div className="col-4">
            <div className={`header-menu ${isMenuOpen ? 'open' : ''}`}>
              <div className="header-menu-close-mobile m-only">
                <span onClick={() => setIsMenuOpen(false)}>
                  <FontAwesomeIcon icon={faTimes} />
                </span>
              </div>
              <ul>
                <li onClick={() => goTo('/gallery/mobil')}>
                  <a href="">Mobil</a>
                </li>
                <li onClick={() => goTo('/gallery/motor')}>
                  <a href="">Motor</a>
                </li>
              </ul>
            </div>
            <div className="header-menu--mobile m-only">
              <span onClick={() => setIsMenuOpen(true)}>
                <img src={require('../../assets/img/hamburger.png')} alt=""/>
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
